import Highcharts from 'highcharts'
import More from 'highcharts/highcharts-more'

More(Highcharts)

export default Highcharts
